// Remember:
// Every file in scripts/ acts as an entry-point and gets tranformed to build/. Feel free to create as much as you want.
// Files in subdirectories will be ignored but you can require them in entry-point-files.
// Add an _ to a file and it will just be ignored(good for tests).
// Add your entry-point-files to templates/layout/yourlayout.html



// NODE MODULES

//=require ../../../node_modules/jquery/dist/jquery.min.js
//=require ../../../node_modules/lazysizes/lazysizes.js
//=require ../../../node_modules/lazysizes/plugins/respimg/ls.respimg.js
//=require ../../../node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks.js
//=require ../../../node_modules/lazysizes/plugins/custommedia/ls.custommedia.js
//=require ../../../node_modules/imagesloaded/imagesloaded.pkgd.js
//=require ../../../node_modules/isotope-layout/dist/isotope.pkgd.js
//=require ../../../node_modules/cookieconsent/build/cookieconsent.min.js
//=require ../../../node_modules/svg4everybody/dist/svg4everybody.min.js

// //=require ../../../node_modules/jquery-hoverintent/jquery.hoverIntent.min.js
// //=require ../../../node_modules/slick-carousel/slick/slick.min.js
//=require ../../../node_modules/aos/dist/aos.js
// //=require ../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js
// //=require ../../../node_modules/sumoselect/jquery.sumoselect.js



// LIBRARIES
// where possible use NPM to install dependencies, since it's version controlled

//=require ../../libraries/velocity.1.5.0.min.js

// //=require ../../libraries/jquery-validation/jquery.validate.js
// //=require ../../libraries/jquery-validation/localization/messages_de.js
// //=require ../../libraries/fraccordion.min.js
// //=require ../../libraries/elementDirectionAndOffsetByScroll.js